import CryptoJS from 'crypto-js';
import { ENCRYPTION_KEY } from './encrypt-key';

export default function decrypt(value: any) {
  return CryptoJS.AES.decrypt(value, ENCRYPTION_KEY)
}